import { CircularProgress } from "@material-ui/core";
import React from "react";

function Loading() {
  return (
    <div style={{ position: "fixed", top: "45%", left: "48%" }}>
      <CircularProgress style={{ height: "100px", width: "100px" }} />
    </div>
  );
}

export default Loading;
